import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
// import pay from "../Assets/pay.png";
// import pay2 from "../Assets/Group 2644.png";
// import pay3 from "../Assets/master.png";
import profile from "../Assets/prof.png";
import {
  getSingleClass,
  bookClass,
  bookClassByPackage,
  selfProfile,
  bookClassByWallet,
  getCourseSlot,
  isUserInWaitlist,
  addToWaitlist,
  removeFromWaitlist,
  createPaymentOrder,
  activePackageSubscription
} from "../Common/apis.js";
import Loader from "../Common/Loader.jsx";
import { toast } from "react-toastify";

function Checkout() {
  const { classId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedDate2 =
    queryParams.get("date") || new Date().toISOString().split("T")[0];
  const [classData, setClassData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isBooking, setIsBooking] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date(selectedDate2).toISOString().split("T")[0]
  );
  const [bookingType, setBookingType] = useState("online");
  // const [walletBalance, setWalletBalance] = useState(0);
  const [availableCount, setavailableCount] = useState(null);
  const [waitlistData, setWaillistData] = useState(null);
  const [isInWaitlist, setIsInWaitlist] = useState(false);
  const [waitlistRank, setWaitlistRank] = useState(null);
  const [packageData, setPackageData] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [isInWaitlistActionInProgress, setIsInWaitlistActionInProgress] =
    useState(false);

  // console.log(classData);
  console.log(waitlistData);
  useEffect(() => {
    checkLoginStatus();
    fetchClassData();
    // fetchWalletData();
  }, []);

  useEffect(() => {
    fetchavailableCount(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    fetchActivePackage();
  }, []);

  useEffect(() => {
    const pendingBookingId = localStorage.getItem("pendingBookingId");
  if (pendingBookingId) {
      fetchClassData(); // Re-fetch updated class info
      fetchActivePackage(); // Maybe updated after booking
      fetchavailableCount(selectedDate); // Slot count update
      // fetchWalletData();     // Optional if wallet used
      localStorage.removeItem("pendingBookingId");
    }
  }, []);

  // console.log(packageData);
  // console.log(classData);
  const handleBuyPackage = () => {
    navigate("/Package");
  };

  const fetchActivePackage = async () => {
    const token = localStorage.getItem("AluraToken");
    if (!token) {
      navigate("/");
      return;
    }
    try {
      const result = await activePackageSubscription();
      setPackageData(result?.data);
    } catch (error) {
      console.error("Error fetching class:", error);
      toast.error("Failed to fetch class details.");
    }
  };

  const checkLoginStatus = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn || isLoggedIn !== "true") {
      toast.error("Please Login First.");
      navigate("/");
    }
  };

  const fetchClassData = async () => {
    const token = localStorage.getItem("AluraToken");
    if (!token) {
      // toast.error("Authentication failed! Please login again.");
      navigate("/");
      return;
    }
    setLoading(true);
    try {
      const result = await getSingleClass(classId);
      setClassData(result?.data);
    } catch (error) {
      console.error("Error fetching class:", error);
      toast.error("Failed to fetch class details.");
    } finally {
      setLoading(false);
    }
  };

  // console.log(waitlistData);
  // console.log(availableCount);

  // const fetchWalletData = async () => {
  //   try {
  //     const token = localStorage.getItem("AluraToken");
  //     if (!token) {
  //       // toast.error("Authentication failed! Please login again.");
  //       navigate("/");
  //       return;
  //     }
  //     const headers = { Authorization: `Bearer ${token}` };
  //     const result = await selfProfile(headers);
  //     setWalletBalance(result?.data?.walletCount || 0);
  //   } catch (error) {
  //     console.error("Error fetching wallet data:", error);
  //     toast.error("Failed to fetch wallet balance.");
  //   }
  // };

  const fetchavailableCount = async (date) => {
    const token = localStorage.getItem("AluraToken");
    if (!token) {
      // toast.error("Authentication failed! Please login again.");
      navigate("/");
      return;
    }
    try {
      // console.log(classId, date);
      const result = await getCourseSlot(classId, date);
      setavailableCount(result?.data?.availableCount || 0);
      const waitListResult = await isUserInWaitlist(classId, date);
      setWaillistData(waitListResult?.data);
      setIsInWaitlist(waitListResult?.data?.isInWaitlist || false);
      setWaitlistRank(waitListResult?.data?.rank || null);
    } catch (error) {
      console.error("Error fetching course slots:", error);
      toast.error("Failed to fetch course slots.");
    }
  };

  const isDateInSchedule = () => {
    if (!classData?.schedule || !selectedDate) return false;

    return classData.schedule.some((dt) => {
      const formatted = new Date(dt?.date).toLocaleDateString("en-CA");
      // console.log(formatted, selectedDate);
      return formatted === selectedDate;
    });
  };

  // console.log(availableCount)

  const handleBooking = async () => {
    // console.log(classData?._id, selectedDate, availableCount,);
    if (
      !classData?._id ||
      !selectedDate ||
      availableCount < 1 ||
      !isDateInSchedule()
    ) {
      toast.error(
        "Please select a valid date with available slots before booking."
      );
      return;
    }

    if (!selectedPackageId) {
      toast.error("Please select a valid package.");
      return;
    }

    const token = localStorage.getItem("AluraToken");
    if (!token) {
      // toast.error("Authentication failed! Please login again.");
      navigate("/");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    const bookingData = {
      courseId: classData?._id,
      date: selectedDate,
      packageSubscriptionId: selectedPackageId
    };

    setIsBooking(true);
    try {
      await bookClassByPackage(bookingData, headers);
      toast.success("Class Booking Successful!");
      navigate("/Booking-Confirmation");
      // if (bookingType === "package") {
      //   await bookClassByPackage(bookingData, headers);
      //   toast.success("Package Booking Successful!");
      // } else if (bookingType === "wallet") {
      //   if (walletBalance < 1) {
      //     toast.error("Insufficient wallet balance.");
      //     return;
      //   }
      //   await bookClassByWallet(bookingData, headers);
      //   toast.success("Wallet Booking Successful!");
      // } else {
      //   const res = await bookClass(bookingData, headers);
      //   // toast.success("Direct Booking Successful!");
      //   if (res?.statusCode == 200) {
      //     const paymentData = await createPaymentOrder({
      //       bookingId: res?.data?._id,
      //       amount: Number(classData?.price) * 100,
      //       currency: "AED"
      //     });
      //     console.log(paymentData?.payment_url);
      //     if (paymentData && paymentData?.payment_url) {
      //       window.location.href = paymentData?.payment_url;
      //     } else {
      //       toast.error(paymentData?.message);
      //     }
      //   }
      // }
      // navigate("/thankyou");
    } catch (error) {
      console.error("Booking failed:", error);
      toast.error(
        error?.response?.data?.message || "Booking failed! Please try again."
      );
    } finally {
      setIsBooking(false);
    }
  };

  const handleDirectBooking = async () => {
    if (!classData?._id || !selectedDate || !isDateInSchedule()) {
      toast.error("Please select a valid date before booking.");
      return;
    }

    const token = localStorage.getItem("AluraToken");
    if (!token) {
      navigate("/");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    const bookingData = {
      courseId: classData._id,
      date: selectedDate
    };

    setIsBooking(true);
    try {
      const res = await bookClass(bookingData, headers); // Direct booking API
      if (res?.statusCode === 200) {
        const bookingId = res?.data?._id;
        localStorage.setItem("pendingBookingId", bookingId);
        const paymentData = await createPaymentOrder({
          bookingId: res.data._id,
          amount: Number(classData.price) * 100,
          currency: "AED"
        });

        if (paymentData?.payment_url) {
          window.location.href = paymentData.payment_url;
        } else {
          toast.error(paymentData?.message || "Payment failed.");
        }
      } else {
        toast.error(res?.message || "Booking failed.");
      }
    } catch (error) {
      console.error("Direct booking error:", error);
      toast.error(error?.response?.data?.message || "Booking failed!");
    } finally {
      setIsBooking(false);
    }
  };

  const handleWaitlist = async () => {
    try {
      setIsInWaitlistActionInProgress(true);
      const token = localStorage.getItem("AluraToken");
      if (!token) {
        // toast.error("Authentication failed! Please login again.");
        navigate("/");
        return;
      }
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        courseId: classId,
        date: selectedDate
      };

      if (isInWaitlist) {
        // Remove from waitlist
        await removeFromWaitlist(payload);
        toast.success("Removed from waitlist.");
        setIsInWaitlist(false);
        setWaitlistRank(null);
      } else {
        // Add to waitlist
        await addToWaitlist(payload);
        toast.success("Added to waitlist.");
        setIsInWaitlist(true);
        setWaitlistRank(waitlistData?.waitlist?.length + 1 || 1);
      }

      // Refresh available count and waitlist status
      fetchavailableCount(selectedDate);
    } catch (error) {
      console.error("Waitlist action failed:", error);
      toast.error(error?.response?.data?.message || "Waitlist action failed.");
    } finally {
      setIsInWaitlistActionInProgress(false);
    }
  };

  const courseServiceId = classData?.service?._id;

  const packageList = packageData.map((pkg) => {
    const inMainServices = pkg.services?.some(
      (service) => service._id === courseServiceId
    );
    const inAdditionalService =
      pkg.additionalService?.service?._id === courseServiceId;

    const additionalRemaining = pkg.additionalService
      ? pkg.additionalService.count - pkg.additionalService.used
      : 0;
    // console.log(inMainServices, inAdditionalService, additionalRemaining);
    // console.log(pkg.additionalService);
    // console.log(pkg)

    const isEligible =
      (inMainServices &&
        (pkg.remainCount > 0 || pkg.packageType === "Unlimited")) ||
      (inAdditionalService && additionalRemaining > 0);

    return {
      ...pkg,
      isEligible,
      serviceMatch: inMainServices || inAdditionalService,
      inMainServices,
      inAdditionalService,
      additionalRemaining
    };
  });

  const sortedPackages = packageList
    .filter((pkg) => pkg.isEligible) // Only show eligible packages
    .sort(
      (a, b) => new Date(a.packageId.endDate) - new Date(b.packageId.endDate)
    );

  // console.log(packageList);
  // console.log(sortedPackages);
  // console.log(selectedPackageId);
  const selectedSchedule = classData?.schedule?.find(
    (dt) => new Date(dt?.date).toLocaleDateString("en-CA") === selectedDate
  );

  useEffect(() => {
    if (sortedPackages.length > 0) {
      if (!selectedPackageId) {
        setSelectedPackageId(sortedPackages[0]._id);
      }
    }
  }, [sortedPackages]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Navbar />
      {isBooking && <Loader />}
      <div className="aboutbanner">
        <h3>Checkout</h3>
        <p>HOME - BOOK CLASSES - {classData?.title} - CHECKOUT</p>
      </div>
      <div className="checkout">
        {/* Left Section - Payment */}
        <div className="checkout-left">
          {/* <div className="Package">
            <p>{classData?.title} Class</p>
          </div> */}
          <br />
          <h3>Selected Date</h3>
          <br />
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            min={new Date().toISOString().split("T")[0]} // Only future dates
            className="styled-date-picker"
            disabled
          />
          <br />
          <br />
          <p>
            Available Slots: {availableCount === null ? "0" : availableCount}
          </p>
          <br />
          {availableCount === 0 && (
            <button
              onClick={handleWaitlist}
              className={
                isInWaitlist ? "remove-waitlist-btn" : "add-waitlist-btn"
              }
            >
              {isInWaitlist
                ? `Remove from Waitlist (Rank: ${waitlistRank})`
                : "Join Waitlist"}
            </button>
          )}
          <br />
          <h3>Selected Package</h3>
          <br />
          <div className="radio-group">
            {/* <select
              onChange={(e) => setSelectedPackageId(e.target.value)}
              value={selectedPackageId}
            >
              <option value="">-- Select a Package --</option>

              {packageList.map((pkg) => {
                const {
                  packageId,
                  _id,
                  services,
                  remainCount,
                  additionalService,
                  isEligible,
                  serviceMatch
                } = pkg;

                const mainServices = services?.map((s) => s.name).join(", ");
                const perServiceCount = remainCount / (services?.length || 1); // assuming equal split

                const additionalLabel = additionalService?.service
                  ? `${additionalService.service.name} (Additional) - ${
                      additionalService.count - additionalService.used
                    } remaining`
                  : null;

                const isDisabled = !serviceMatch || !isEligible;

                const labelLines = [
                  `${packageId.name}`,
                  ...services?.map(
                    (s) =>
                      `  • ${s.name} - ${Math.floor(perServiceCount)} remaining`
                  )
                ];

                if (
                  additionalService?.service &&
                  additionalService.count - additionalService.used > 0
                ) {
                  labelLines.push(
                    `  ➕ ${additionalService.service.name} (Additional) - ${
                      additionalService.count - additionalService.used
                    } remaining`
                  );
                }

                if (!serviceMatch) {
                  labelLines.push("Not valid for this class");
                } else if (!isEligible) {
                  labelLines.push("No remaining count");
                }

                return (
                  <option key={_id} value={_id} disabled={isDisabled}>
                    {labelLines.join("\n")}
                  </option>
                );
              })}
            </select> */}

            {/* <select
              onChange={(e) => setSelectedPackageId(e.target.value)}
              value={selectedPackageId}
              className="selection-package"
            >
              <option value="">Selected a Package</option>

              {packageList.map((pkg) => {
                const {
                  packageId,
                  _id,
                  isEligible,
                  inMainServices,
                  inAdditionalService,
                  remainCount,
                  additionalRemaining,
                  serviceMatch
                } = pkg;

                let label = `${packageId?.name}`;

                const detailParts = [];

                // Main service count
                if (inMainServices) {
                  detailParts.push(`${remainCount} Main Remaining`);
                }

                // Always show additional
                detailParts.push(`${additionalRemaining} Additional Remaining`);

                // Join details
                if (detailParts.length > 0) {
                  label += ` - ${detailParts.join(" | ")}`;
                }

                // Add status markers
                if (!serviceMatch) {
                  label += "(Not valid for this class)";
                } else if (!isEligible) {
                  label += "(No remaining count)";
                }

                // Decide disabling
                const shouldDisable = !serviceMatch || !isEligible;

                return (
                  <option key={_id} value={_id} disabled={shouldDisable}>
                    {label}
                  </option>
                );
              })}
            </select> */}
            {/* <button
              className={`radio-btn ${
                bookingType === "online" ? "selected" : ""
              }`}
              onClick={() => setBookingType("online")}
              disabled={availableCount <= 0}
            >
              Online Payment
            </button> */}

            {/* <button
              className={`radio-btn ${
                bookingType === "package" ? "selected" : ""
              }`}
              onClick={() => setBookingType("package")}
              disabled={availableCount <= 0}
            >
              Using Package
            </button> */}

            {/* <button
              className={`radio-btn ${
                bookingType === "wallet" ? "selected" : ""
              }`}
              onClick={() => setBookingType("wallet")}
              disabled={walletBalance === 0 || availableCount <= 0}
            >
              Using Wallet (Balance: {walletBalance})
            </button> */}

            {/* {sortedPackages.map((pkg) => {
              const {
                packageId,
                _id,
                inMainServices,
                inAdditionalService,
                remainCount,
                additionalRemaining,
              } = pkg;

              let label = `${packageId?.name}`;

              const detailParts = [];

              // Main service count
              if (inMainServices) {
                detailParts.push(`${remainCount} Main Remaining`);
              }

              // Always show additional
              detailParts.push(`${additionalRemaining} Additional Remaining`);

              // Join details
              if (detailParts.length > 0) {
                label += ` - ${detailParts.join(" | ")}`;
              }

              return (
                <div
                  key={_id}
                  className={`package-box ${selectedPackageId === _id ? "selected" : ""}`}
                >
                  <input
                    type="radio"
                    id={`package-${_id}`}
                    name="package"
                    value={_id}
                    checked={selectedPackageId === _id}
                    onChange={() => setSelectedPackageId(_id)}
                  />
                  <label htmlFor={`package-${_id}`}>
                    <p>{label}</p>
                    <p>
                      Ends on:{" "}
                      {new Date(pkg?.endDate).toLocaleDateString("en-GB", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                    </p>
                  </label>
                </div>
              );
            })} */}
            {sortedPackages.length > 0 ? (
              sortedPackages.some((pkg) => pkg._id === selectedPackageId) ? (
                sortedPackages.map((pkg) => {
                  if (pkg._id === selectedPackageId) {
                    return (
                      <div key={pkg._id} className="package-box selected">
                        <h5>{pkg.packageId?.name?.toUpperCase()}</h5>
                      </div>
                    );
                  }
                  return null;
                })
              ) : (
                <div className="no-package-box">
                  <p>No package found</p>
                  <br />
                  <button
                    className="sub package-btn"
                    style={{
                      width: "150px",
                      cursor: "pointer",
                      borderRadius: "5px",
                      lineHeight: "30px"
                    }}
                    onClick={handleBuyPackage}
                  >
                    Buy Package
                  </button>
                </div>
              )
            ) : (
              <div className="no-package-box">
                <p>No package found</p>
                <br />
                <button
                  className="sub package-btn"
                  style={{
                    width: "150px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    lineHeight: "30px"
                  }}
                  onClick={handleBuyPackage}
                >
                  Buy Package
                </button>
              </div>
            )}
          </div>
          <br />
          {/* <br />
          <h3>Payment Method</h3>
          <br />
          <div className="PaymentMethod">
            <img src={pay} alt="Payment Method 1" />
            <img src={pay2} alt="Payment Method 2" />
            <img src={pay3} alt="Payment Method 3" />
          </div> */}
          <br />
          {/* <div className="checkout-form">
            <h3>Credit / Debit Card</h3>
            <br />
            <label>Card Number</label>
            <input placeholder="Enter Card Number" />
            <br />
            <label>Card Holder Name</label>
            <input placeholder="Enter Holder Name" />
            <br />
            <label>Exp. Date</label>
            <input placeholder="MM/YY" />
            <br />
            <label>Cvv</label>
            <input placeholder="Enter CVV" />
            <br />
            <div className="checkout-btns">
              <button>Cancel</button>
              <button
                className="sub"
                disabled={isBooking}
                onClick={handleBooking}
              >
                {isBooking ? "Processing..." : "Submit"}
              </button>
            </div>
          </div> */}
        </div>

        {/* Right Section - Class Details */}
        <div className="checkout-right">
          <div className="checkout-profile">
            <img src={profile} alt="Profile" />
            <div>
              <h3>{classData?.title}</h3>
              <p>{classData?.description}</p>
              <p>Selected Date: {selectedDate}</p>

              <p>
                Time:{" "}
                {/* {new Date(classData?.startTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit"
                })}{" "}
                -{" "}
                {new Date(classData?.endTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit"
                })} */}
                {selectedSchedule?.startTime} - {selectedSchedule?.endTime}
              </p>
              {/* <p>Slots: {availableCount === null ? "0" : availableCount}</p> */}
              <p>
                Slots:{" "}
                {availableCount === null
                  ? `0/${classData?.maxCapacity || 0}`
                  : `${availableCount}/${classData?.maxCapacity || 0}`}
              </p>
            </div>
          </div>
          {/* {availableCount !== 0 && (
            <button
              onClick={handleWaitlist}
              className={
                isInWaitlist ? "remove-waitlist-btn" : "add-waitlist-btn"
              }
            >
              {isInWaitlist
                ? `Remove from Waitlist (Rank: ${waitlistRank})`
                : "Join Waitlist"}
            </button>
          )} */}
          <br />
          <p className="Selected-new">
            Selected Package:
            <span>
              {sortedPackages.length > 0 ? (
                sortedPackages.some((pkg) => pkg._id === selectedPackageId) ? (
                  sortedPackages.map((pkg) => {
                    if (pkg._id === selectedPackageId) {
                      return (
                        <div key={pkg._id} className="package-box selected">
                          <h5 style={{ fontSize: "16px" }}>
                            {pkg.packageId?.name?.toUpperCase()}
                          </h5>
                        </div>
                      );
                    }
                    return null;
                  })
                ) : (
                  <div className="no-package-box">
                    {/* <p>No package found</p> */}
                    <br />
                    <button
                      className="sub package-btn"
                      // style={{
                      //   width: "150px",
                      //   cursor: "pointer",
                      //   borderRadius: "5px",
                      //   lineHeight: "30px"
                      // }}
                      onClick={handleBuyPackage}
                    >
                      Buy Package
                    </button>
                  </div>
                )
              ) : (
                <div className="no-package-box">
                  {/* <p>No package found</p> */}
                  <br />
                  <button
                    className="sub package-btn"
                    // style={{
                    //   width: "150px",
                    //   cursor: "pointer",
                    //   borderRadius: "5px",
                    //   lineHeight: "30px"
                    // }}
                    onClick={handleBuyPackage}
                  >
                    Buy Package
                  </button>
                </div>
              )}
            </span>
          </p>
          <br />

          <div className="checkout-bill">
            {/* <h3>Bill Details</h3>
            <br />
            <div className="subtotal">
              <p>Class Price</p>
              <p>
                <b>AED {classData?.price}</b>
              </p>
            </div>
            <br />
            <div className="subtotal">
              <p>Tax (5%)</p>
              <p>
                <b>AED {(classData?.price * 0.05).toFixed(2)}</b>
              </p>
            </div>
            <br />
            <div className="subtotal">
              <p>Total</p>
              <p>
                <b>AED {(classData?.price * 1.05).toFixed(2)}</b>
              </p>
            </div> */}
            <button
              onClick={() => {
                if (availableCount > 0) {
                  if (sortedPackages.length === 0) {
                    handleDirectBooking();
                  } else {
                    handleBooking();
                  }
                } else {
                  handleWaitlist();
                }
              }}
              disabled={
                isBooking ||
                (availableCount <= 0 && isInWaitlistActionInProgress)
              }
            >
              {availableCount > 0
                ? isBooking
                  ? "Booking..."
                  : sortedPackages.length === 0
                  ? `Pay ${classData?.price} AED` // price for direct booking
                  : "Confirm Booking"
                : isInWaitlist
                ? `Remove from Waitlist (Rank: ${waitlistRank})`
                : "Join Waitlist"}
            </button>

            {/* <button
              onClick={() => {
                if (availableCount > 0) {
                  handleBooking();
                } else {
                  handleWaitlist();
                }
              }}
              disabled={
                isBooking ||
                (availableCount <= 0 && isInWaitlistActionInProgress)
              }
            >
              {availableCount > 0
                ? isBooking
                  ? "Booking..."
                  : "Confirm Booking"
                : isInWaitlist
                ? `Remove from Waitlist (Rank: ${waitlistRank})`
                : "Join Waitlist"}
            </button> */}

            {/* {bookingType === "online" && ( */}
            {/* <button
                onClick={handleBooking}
                disabled={isBooking || availableCount <= 0}
              >
                {isBooking ? "Booking..." : "Confirm Booking"}
              </button> */}
            {/* )} */}

            {/* {bookingType === "package" && (
              <button
                className="sub package-btn"
                disabled={isBooking || availableCount <= 0}
                onClick={() => handleBooking(true)}
              >
                {isBooking ? "Processing..." : "Package Book"}
              </button>
            )}

            {bookingType === "wallet" && (
              <button
                className="sub wallet-btn"
                disabled={isBooking || availableCount <= 0}
                onClick={() => handleBooking(false)}
              >
                {isBooking ? "Processing..." : "Wallet Book"}
              </button>
            )} */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Checkout;
